import { render, staticRenderFns } from "./ChooseCaptainMulti.vue?vue&type=template&id=eff5fa24&scoped=true"
import script from "./ChooseCaptainMulti.vue?vue&type=script&lang=js"
export * from "./ChooseCaptainMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff5fa24",
  null
  
)

export default component.exports